import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Collapse } from 'react-bootstrap';
import classNames from 'classnames';

import { createUseThemedStyles } from '@/hooks';
import { NaviationSectionLink } from '@/components';
import { ReactComponent as DownChevron } from '@/assets/icons/icon-chevron-down.svg';

const useStyles = createUseThemedStyles((theme) => ({
	navigationList: {
		margin: 0,
		padding: 0,
		listStyle: 'none',
		'& li': {
			borderBottom: `1px solid ${theme.colors.gray300}`,
			'& a, & button': {
				width: '100%',
				display: 'block',
				textAlign: 'left',
				padding: '16px 24px',
			},
			'&:last-of-type': {
				margin: 0,
			},
		},
	},
	navigationCollapseList: {
		margin: 0,
		listStyle: 'none',
		padding: '16px 24px',
		backgroundColor: theme.colors.gray100,
		borderBottom: `1px solid ${theme.colors.gray300}`,
		'& li': {
			marginBottom: 8,
			'& a': {
				display: 'block',
			},
			'&:last-of-type': {
				margin: 0,
			},
		},
	},
	chevron: {
		transition: '200ms transform',
	},
	flip: {
		transform: 'rotate(180deg)',
	},
}));

interface HeaderMenuAccordionProps {
	title: string;
	links: NaviationSectionLink[];
	aside?: JSX.Element;
}

export const HeaderMenuAccordion = ({ title, links, aside }: HeaderMenuAccordionProps) => {
	const classes = useStyles();
	const [show, setShow] = useState(false);

	return (
		<>
			<ul className={classes.navigationList}>
				<li>
					<Button
						className="d-flex align-items-center justify-content-between"
						variant="link"
						onClick={() => {
							setShow(!show);
						}}
					>
						{title}
						<DownChevron
							className={classNames(classes.chevron, {
								[classes.flip]: show,
							})}
						/>
					</Button>
				</li>
			</ul>
			<Collapse in={show}>
				<div>
					<ul className={classes.navigationCollapseList}>
						{links.map((link, linkIndex) => {
							if (link.external) {
								return (
									<li key={linkIndex}>
										<a
											href={link.to}
											target="_blank"
											rel="noreferrer"
											onClick={link.onClick}
											dangerouslySetInnerHTML={{ __html: link.mobileTitle ?? link.title }}
										/>
									</li>
								);
							} else {
								return (
									<li key={linkIndex}>
										<Link
											to={link.to}
											onClick={link.onClick}
											dangerouslySetInnerHTML={{ __html: link.mobileTitle ?? link.title }}
										/>
									</li>
								);
							}
						})}
						{aside}
					</ul>
				</div>
			</Collapse>
		</>
	);
};
